// extracted by mini-css-extract-plugin
module.exports = {"vanlife-A":"A_vanlife-A__AynMU"};